<template>
  <div class="article-container">

    <h1 class="news-title">{{ $t('newsinfo.ciif.title') }}</h1>
    
    <div class="rich_media_content autoTypeSetting24psection" id="js_content">
      <section class="main-section">
        <!-- 顶部图片 -->
        <section class="section-image">
          <img 
            src="https://www.healthcode.com/media/news/ciif_files/640.jpg" 
            :alt="$t('newsinfo.ciif.images.ciifExpo')"
          >
        </section>
        
        <!-- 标题图片 -->
        <section class="section-image">
          <img 
            src="https://www.healthcode.com/media/news/ciif_files/640(1).jpg" 
            :alt="$t('newsinfo.ciif.images.healthcodeAward')"
          >
        </section>
        
        <!-- 标题装饰部分 -->
        <section class="title-decoration-section">
          <div class="decoration-left">
            <div class="decoration-inner">
              <div class="small-circle"></div>
              <div class="rotated-element">
                <div class="circle-with-shadow"></div>
                <div class="arc-line"></div>
              </div>
            </div>
          </div>
          <div class="title-content">
            <div class="title-inner">
              <p><strong>{{ $t('newsinfo.ciif.subtitle') }}</strong></p>
            </div>
          </div>
        </section>
        
        <!-- 引言区域 -->
        <section class="intro-box">
          <div class="intro-border">
            <div class="intro-inner">
              <p class="intro-text">
                <span class="highlight-blue">
                  {{ $t('newsinfo.ciif.intro.main') }}
                  <span> {{ $t('newsinfo.ciif.intro.punctuation') }}</span>
                </span>
              </p>
            </div>
          </div>
        </section>
        
        <!-- 奖项展示图片 -->
        <section class="section-image">
          <img 
            src="https://www.healthcode.com/media/news/ciif_files/640(2).jpg" 
            :alt="$t('newsinfo.ciif.images.awardDisplay')"
          >
        </section>
        
        <!-- 国家级工业荣誉部分 -->
        <section class="content-block">
          <div class="block-decoration">
            <div class="decoration-left">
              <div class="decoration-inner">
                <div class="rotated-element">
                  <div class="circle-with-shadow"></div>
                  <div class="arc-line"></div>
                </div>
              </div>
            </div>
            <div class="block-title">
              <p><strong>{{ $t('newsinfo.ciif.awardSection.title') }}</strong></p>
            </div>
          </div>
          
          <div class="block-content">
            <div class="content-left-border"></div>
            <div class="content-inner">
              <p class="content-text indent-text">
                {{ $t('newsinfo.ciif.awardSection.description') }}
              </p>
              <p class="content-text"><br></p>
              <p class="content-text indent-text">
                {{ $t('newsinfo.ciif.awardSection.coWinners') }}
              </p>
            </div>
          </div>
          
          <!-- 内容图片 -->
          <section class="section-image">
            <img 
              src="https://www.healthcode.com/media/news/ciif_files/640-4.jpg" 
              :alt="$t('newsinfo.ciif.images.industryHonor')"
            >
          </section>
        </section>
        
        <!-- 突破卡脖子技术部分 -->
        <section class="content-block">
          <div class="block-decoration blue-bg">
            <div class="decoration-left">
              <div class="decoration-inner">
                <div class="rotated-element">
                  <div class="circle-with-shadow dark-blue"></div>
                  <div class="arc-line"></div>
                </div>
              </div>
            </div>
            <div class="block-title">
              <p><strong>{{ $t('newsinfo.ciif.breakthroughSection.title') }}</strong></p>
              <p><strong>{{ $t('newsinfo.ciif.breakthroughSection.subtitle') }}</strong></p>
            </div>
          </div>
          
          <div class="block-content">
            <div class="content-left-border light-blue"></div>
            <div class="content-inner">
              <p class="content-text indent-text">
                {{ $t('newsinfo.ciif.breakthroughSection.mainContent') }}
              </p>
              <p class="content-text"><br></p>
              <p class="content-text indent-text">
                {{ $t('newsinfo.ciif.breakthroughSection.innovation') }}
              </p>
            </div>
          </div>
          
          <!-- 技术图片1 -->
          <section class="section-image">
            <img 
              src="https://www.healthcode.com/media/news/ciif_files/640-5.jpg" 
              :alt="$t('newsinfo.ciif.images.proteinTech')"
            >
          </section>
          
          <div class="block-content">
            <div class="content-left-border light-blue"></div>
            <div class="content-inner">
              <p class="content-text indent-text">
                <span class="transparent-bg">{{ $t('newsinfo.ciif.breakthroughSection.plasma') }}</span>
              </p>
              <p class="content-text"><br></p>
              <p class="content-text indent-text">
                <span class="transparent-bg">{{ $t('newsinfo.ciif.breakthroughSection.proteinTech') }}</span>
              </p>
              <p class="content-text"><br></p>
              <p class="content-text indent-text">
                <span class="transparent-bg">{{ $t('newsinfo.ciif.breakthroughSection.selfReliance') }}</span>
              </p>
              <p class="content-text indent-text"><br></p>
              <p class="content-text indent-text">
                <span class="transparent-bg">{{ $t('newsinfo.ciif.breakthroughSection.explanation') }}</span>
              </p>
            </div>
          </div>
          
          <!-- 技术图片2 -->
          <section class="section-image">
            <img 
              src="https://www.healthcode.com/media/news/ciif_files/640-6.jpg" 
              :alt="$t('newsinfo.ciif.images.bioManufacturingLine')"
            >
          </section>
          
          <div class="block-content">
            <div class="content-left-border light-blue"></div>
            <div class="content-inner">
              <p class="content-text indent-text">
                <span class="transparent-bg">{{ $t('newsinfo.ciif.breakthroughSection.achievement') }}</span>
              </p>
            </div>
          </div>
        </section>
        
        <!-- 创新驱动发展部分 -->
        <section class="content-block">
          <div class="block-decoration">
            <div class="decoration-left">
              <div class="decoration-inner">
                <div class="rotated-element">
                  <div class="circle-with-shadow"></div>
                  <div class="arc-line"></div>
                </div>
              </div>
            </div>
            <div class="block-title">
              <p><strong>{{ $t('newsinfo.ciif.innovationSection.title') }}</strong></p>
            </div>
          </div>
          
          <div class="block-content">
            <div class="content-left-border light-blue"></div>
            <div class="content-inner">
              <p class="content-text indent-text">
                {{ $t('newsinfo.ciif.innovationSection.content') }}
              </p>
            </div>
          </div>
          
          <!-- 研发团队图片 -->
          <section class="section-image">
            <img 
              src="https://www.healthcode.com/media/news/ciif_files/640-7.jpg" 
              :alt="$t('newsinfo.ciif.images.rAndDTeam')"
            >
          </section>
        </section>
        
        <!-- 砥砺前行部分 -->
        <section class="content-block">
          <div class="block-decoration">
            <div class="decoration-left">
              <div class="decoration-inner">
                <div class="rotated-element">
                  <div class="circle-with-shadow"></div>
                  <div class="arc-line"></div>
                </div>
              </div>
            </div>
            <div class="block-title">
              <p><strong>{{ $t('newsinfo.ciif.futureSection.title') }}</strong></p>
            </div>
          </div>
          
          <div class="block-content">
            <div class="content-left-border light-blue"></div>
            <div class="content-inner">
              <p class="content-text indent-text">
                {{ $t('newsinfo.ciif.futureSection.content') }}
              </p>
            </div>
          </div>
          
          <!-- 未来发展图片 -->
          <section class="section-image">
            <img 
              src="https://www.healthcode.com/media/news/ciif_files/640-8.jpg" 
              :alt="$t('newsinfo.ciif.images.futurePlan')"
            >
          </section>
          
          <div class="block-content">
            <div class="content-left-border light-blue"></div>
            <div class="content-inner">
              <p class="content-text indent-text">
                <span class="transparent-bg">{{ $t('newsinfo.ciif.futureSection.commitment') }}</span>
              </p>
            </div>
          </div>
          
          <!-- 关于工博会部分 -->
          <section class="nested-block">
            <div class="block-decoration">
              <div class="decoration-left">
                <div class="decoration-inner">
                  <div class="rotated-element">
                    <div class="circle-with-shadow"></div>
                    <div class="arc-line"></div>
                  </div>
                </div>
              </div>
              <div class="block-title">
                <p><strong>{{ $t('newsinfo.ciif.fairInfo.title') }}</strong></p>
              </div>
            </div>
            
            <div class="nested-content">
              <div class="content-left-border light-blue"></div>
              <div class="nested-inner">
                <!-- 工博会图片1 -->
                <section class="section-image">
                  <img 
                    src="https://www.healthcode.com/media/news/ciif_files/640-9.jpg" 
                    :alt="$t('newsinfo.ciif.images.chinaIndustryFair')"
                  >
                </section>
                
                <div class="nested-text-content">
                  <p class="content-text indent-text">
                    {{ $t('newsinfo.ciif.fairInfo.description') }}
                  </p>
                  <p class="content-text"><br></p>
                  <p class="content-text indent-text">
                    {{ $t('newsinfo.ciif.fairInfo.significance') }}
                  </p>
                  <p class="content-text"><br></p>
                  <p class="content-text indent-text">
                    {{ $t('newsinfo.ciif.fairInfo.evolution') }}
                  </p>
                </div>
                
                <!-- 工博会图片2 -->
                <section class="section-image">
                  <img 
                    src="https://www.healthcode.com/media/news/ciif_files/640-10.jpg" 
                    :alt="$t('newsinfo.ciif.images.exhibitionScene')"
                  >
                </section>
              </div>
            </div>
          </section>
          
          <!-- 结语 -->
          <div class="conclusion-content">
            <p class="conclusion-text indent-text">
              <strong class="transparent-bg">{{ $t('newsinfo.ciif.conclusion') }}</strong>
            </p>
          </div>
        </section>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale, t } = useI18n();

const currentLang = computed(() => locale.value);

const switchLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem('locale', lang);
};

// 监听语言变化并执行相应操作
watch(locale, (newLocale) => {
  console.log(`语言已切换到: ${newLocale}`);
});
</script>

<style scoped>
/* 基础容器样式 */
.article-container {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  color: #3e3e3e;
  line-height: 1.6;
  background-color: #fff;
}

/* 语言切换按钮样式 */
.language-switcher {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
  display: flex;
  gap: 5px;
}

.language-switcher button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.language-switcher button:hover {
  background-color: #e0e0e0;
}

.language-switcher button.active {
  background-color: #2e3b7a;
  color: white;
  border-color: #2e3b7a;
}

.news-title {
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0 12px;
  color: #232323;
  line-height: 1.4;
  margin-top: 100px;
}

.rich_media_content {
  padding: 0 10px;
  box-sizing: border-box;
}

/* 通用图片样式 */
.section-image {
  text-align: center;
  margin: 10px 0;
  line-height: 0;
}

.section-image img {
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
}

/* 标题装饰部分 */
.title-decoration-section {
  display: flex;
  flex-flow: row;
  margin: 10px 0 0;
  text-align: left;
  justify-content: flex-start;
  align-items: flex-end;
}

.decoration-left {
  display: inline-block;
  width: auto;
  vertical-align: bottom;
  background-color: #ddeaff;
  min-width: 10%;
  max-width: 100%;
  flex: 0 0 auto;
  height: auto;
  align-self: flex-end;
  padding: 9px 33px 15px 10px;
  margin: 0;
  line-height: 0;
  position: relative;
  z-index: 2;
}

.decoration-inner {
  position: relative;
}

.small-circle {
  text-align: center;
  margin: 0 0 14px;
}

.small-circle::before {
  content: '';
  display: inline-block;
  width: 9px;
  height: 9px;
  background-color: #fff;
  border-radius: 107px;
}

.rotated-element {
  transform: rotate(340deg);
}

.circle-with-shadow {
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  height: 23px;
  width: 23px;
  background-color: #ddeaff;
  border-radius: 134px;
  box-shadow: #2e3b7a -4px -4px 8px inset;
}

.circle-with-shadow.dark-blue {
  background-color: #bdd4fd;
}

.arc-line {
  margin: -17px 0 10px;
}

.arc-line::before {
  content: '';
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  height: 8px;
  width: 31px;
  background-color: transparent;
  border: 1px solid;
  border-radius: 100%;
  border-color: transparent #2e3b7a #2e3b7a;
}

.title-content {
  display: inline-block;
  vertical-align: bottom;
  width: auto;
  flex: 100 100 0%;
  align-self: flex-end;
  height: auto;
  background-color: transparent;
  margin: 0 0 0 -20px;
  padding: 0;
}

.title-inner {
  display: flex;
  flex-flow: row;
  margin: 0;
  text-align: justify;
  justify-content: flex-start;
  background-color: #f3f7ff;
  border-style: solid;
  border-width: 0 0 12px;
  border-color: #ddeaff;
  padding: 0 0 0 30px;
  align-items: center;
  min-height: 60px;
}

.title-inner p {
  margin: 0;
  padding: 0;
  color: #2e3b7a;
  font-size: 18px;
  line-height: 2;
}

.title-inner strong {
  font-size: 16px;
}

/* 引言区域 */
.intro-box {
  text-align: center;
  justify-content: center;
  margin: 0 0 10px;
  display: flex;
  flex-flow: row;
  width: 100%;
  background-color: #ddeaff;
  padding: 13px;
  height: auto;
  align-self: flex-start;
  font-size: 16px;
}

.intro-border {
  justify-content: center;
  margin: 0;
  display: flex;
  flex-flow: row;
  width: 100%;
  border: 2px solid #7198dc;
  height: auto;
  background-color: #f3f7ff;
  align-self: flex-start;
}

.intro-inner {
  margin: 20px 0;
  width: 100%;
}

.intro-text {
  margin: 0;
  padding: 0 25px;
  text-align: left;
  text-indent: 2em;
  color: #2e3b7a;
}

.highlight-blue {
  color: #2e3b7a;
}

/* 内容区块通用样式 */
.content-block {
  margin: 20px 0;
}

.block-decoration {
  display: flex;
  flex-flow: row;
  margin: 0;
  text-align: left;
  justify-content: flex-start;
  align-items: stretch;
}

.block-decoration.blue-bg .decoration-left {
  background-color: #ddeaff;
}

.block-decoration .decoration-left {
  display: inline-block;
  width: auto;
  vertical-align: top;
  background-color: #ddeaff;
  min-width: 10%;
  max-width: 100%;
  flex: 0 0 auto;
  height: auto;
  align-self: stretch;
  padding: 10px;
  z-index: 1;
  margin: 0;
}

.block-title {
  display: inline-block;
  flex: 0 0 auto;
  vertical-align: top;
  align-self: stretch;
  width: auto;
  min-width: 10%;
  max-width: 100%;
  height: auto;
  background-color: #f3f7ff;
  border-style: solid;
  border-width: 0 0 12px;
  border-color: #ddeaff;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
}

.block-title p {
  margin: 0;
  padding: 0 19px;
  color: #2e3b7a;
  font-size: 16px;
  line-height: 1.5;
}

/* 内容区域 */
.block-content {
  text-align: left;
  justify-content: flex-start;
}

.content-left-border {
  display: inline-block;
  width: 100%;
  vertical-align: top;
  background-color: transparent;
  border-left: 2px solid #f3f7ff;
  border-bottom-left-radius: 0;
  align-self: flex-start;
  flex: 0 0 auto;
  min-width: 2px;
}

.content-left-border.light-blue {
  border-left: 2px solid #ddeaff;
}

.content-inner {
  margin: 15px 0 26px;
  flex: 1;
}

.content-text {
  margin: 0;
  padding: 0 21px;
  color: #1f1f1f;
  font-size: 16px;
  line-height: 1.8;
}

.indent-text {
  text-indent: 2em;
}

.transparent-bg {
  background-color: transparent;
}

/* 嵌套区块 */
.nested-block {
  margin: 20px 0;
}

.nested-content {
  justify-content: flex-start;
}

.nested-inner {
  display: inline-block;
  width: 100%;
  vertical-align: top;
  background-color: transparent;
  border-left: 2px solid #ddeaff;
  border-bottom-left-radius: 0;
  align-self: flex-start;
  flex: 0 0 auto;
}

.nested-text-content {
  margin: 15px 0 26px;
}

/* 结语样式 */
.conclusion-content {
  margin: 15px 0 26px;
}

.conclusion-text {
  color: #2e3b7a;
  padding: 0 21px;
  font-size: 16px;
  line-height: 1.8;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .article-container {
    padding: 0 8px;
  }
  
  .language-switcher {
    position: static;
    justify-content: center;
    margin-bottom: 15px;
  }
  
  .title-decoration-section {
    flex-direction: column;
  }
  
  .decoration-left {
    width: 100%;
    text-align: center;
    padding: 15px;
    margin-bottom: -10px;
  }
  
  .title-content {
    margin: 0;
    width: 100%;
  }
  
  .title-inner {
    padding: 15px;
  }
  
  .block-decoration {
    flex-direction: column;
  }
  
  .block-decoration .decoration-left {
    width: 100%;
    text-align: center;
    padding: 15px;
  }
  
  .block-title {
    width: 100%;
  }
  
  .content-text,
  .conclusion-text {
    font-size: 15px;
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .article-container {
    padding: 0 5px;
  }
  
  .intro-text {
    padding: 0 15px;
  }
  
  .title-inner p,
  .block-title p {
    font-size: 14px;
  }
  
  .content-text,
  .conclusion-text {
    font-size: 14px;
    padding: 0 10px;
  }
}

/* 打印优化 */
@media print {
  .article-container {
    max-width: 100%;
    padding: 0;
  }
  
  .section-image img {
    max-height: 200px;
    object-fit: contain;
  }
  
  .decoration-left,
  .title-content,
  .intro-box,
  .block-decoration {
    break-inside: avoid;
  }
}
</style>